// TES-1209 — which columns "Patienter" shows, per view. Pure, so the choice
// is testable without a DOM.
//
// The doctor's list is unchanged. The coach's follows A-01, "Patientöversikt":
// "MVP visar patient, aktuell fas, behandlingsstatus, senaste incheckning, antal öppna ärenden, senaste kontakt och sökning. Registreringsdatum är inte en prioriteringskolumn."
// So the registration date goes, and so does the latest health declaration
// (any form, the doctor's material); the latest weekly check-in, the open
// cases and the latest contact come in.

export type PatientListColumn =
  | "patient"
  | "journey"
  | "status"
  | "treatment"
  | "latestDeclaration"
  | "registered"
  | "latestCheckin"
  | "openCases"
  | "latestContact";

export const PATIENT_LIST_COLUMN_LABEL: Record<PatientListColumn, string> = {
  patient: "Patient",
  journey: "Resa",
  status: "Aktuell status",
  treatment: "Behandling",
  latestDeclaration: "Senaste hälsodeklaration",
  registered: "Registrerad",
  // TES-1209: proposed, from A-01's own words for the three columns.
  latestCheckin: "Senaste incheckning",
  openCases: "Öppna ärenden",
  latestContact: "Senaste kontakt",
};

const DOCTOR_COLUMNS: readonly PatientListColumn[] = [
  "patient",
  "journey",
  "status",
  "treatment",
  "latestDeclaration",
  "registered",
];

const COACH_COLUMNS: readonly PatientListColumn[] = [
  "patient",
  "journey",
  "status",
  "treatment",
  "latestCheckin",
  "openCases",
  "latestContact",
];

export function patientListColumns(
  view: "doctor" | "coach",
): readonly PatientListColumn[] {
  return view === "coach" ? COACH_COLUMNS : DOCTOR_COLUMNS;
}

/**
 * The coach columns' dates: the reader's own calendar day (YYYY-MM-DD), or a
 * dash when there is none. Not the UTC day: a message written at 00:30 in
 * Stockholm belongs to that day.
 */
export function coachListDay(ts: string | null | undefined): string {
  return ts ? new Date(ts).toLocaleDateString("sv-SE") : "—";
}
